<template>
  <div class="dev-home">
    <div class="row">
      <el-container>
        <el-header>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo dev-main"
            mode="horizontal"
            style="margin: 0 auto"
            active-text-color="#ffd04b">
            <el-menu-item index="0">
              <router-link :to="{ path: '/'}"><img style="margin-right: 20px;width: 83px" :src="$baseUrl+'img/paraverse-dev-logo.png'"/>
              </router-link>
            </el-menu-item>
            <el-menu-item index="2"><a href="https://www.pingxingyun.com/devCenter.html" target="_blank">手册</a></el-menu-item>
            <el-menu-item index="3"><a href="https://www.pingxingyun.com/online/api.html?id=294" target="_blank">API</a></el-menu-item>
            <el-menu-item index="4"><a href="https://www.pingxingyun.com/devCenter.html" target="_blank">下载</a></el-menu-item>
           <!-- <el-menu-item index="5">
              <router-link :to="{ path: '/activity/index'}">活动</router-link>
            </el-menu-item>-->
            <el-menu-item index="6">
             <!-- <router-link :to="{ path: 'https://www.pingxingyun.com/community/classify'}">社区</router-link>-->
              <el-link href="https://www.pingxingyun.com/community/classify" target="_blank">
                社区
              </el-link>
            </el-menu-item>
            <div class="fr" style="margin-top: 20px;margin-right:5px;cursor: pointer">

              <router-link v-if="user && user.loginId && user.loginId != null" :to="{path:'/console'}" class="dev-oper">控制台
              </router-link>
              <div v-else>
                <router-link :to="{path:'/register'}" class="dev-oper">注册/</router-link>
                <router-link :to="{path:'/login'}" class="dev-oper">登录</router-link>
              </div>

            </div>
          </el-menu>

        </el-header>
        <el-main>
          <keep-alive>
            <router-view @setActiveIndex='setActiveIndex' v-if="this.$route.meta.keepAlive">
            </router-view>
          </keep-alive>
          <router-view @setActiveIndex='setActiveIndex' v-if="!this.$route.meta.keepAlive"></router-view>

        </el-main>
        <el-footer>
          <div class="dev-footer">

            <div class="slogan">
              Paraverse Here is New-Gen Web
            </div>

          </div>
          <div style="width: 750px;max-width:100%;margin: 0 auto" class="clearfix vertical">
            <p style="color: #666666;float: left; font-size: 20px;color: #000000;margin: 40px 0">©2016-2031 pingxingyun.com All Rights Reserved</p>
            <div style="float: right;margin: 40px 0">
              <img :src="$baseUrl+'img/logo.png'" style="width: 35px"/>
              <!-- <span style="vertical-align: middle;display: inline-block;font-size: 16px" class="main-color">关于平行云</span> -->
            </div>
          </div>

        </el-footer>
      </el-container>
    </div>
  </div>

</template>
<script>
  import {Message, MessageBox} from "element-ui";

  export default {
    data() {
      return {
        isCollapse: true,
        activeIndex: '1',
      }
    },
    mounted: function () {
    },

    methods: {
      setActiveIndex: function (data) {
        this.activeIndex = data;
      },
    },

    computed: {
      user() {
        return this.$store.state.user;
      },
      routes() {
        return this.$store.state.routes
      }
    }
  }
</script>
<style>

</style>
